// extracted by mini-css-extract-plugin
export default {"pointbody":"Point_pointbody__FwXKd","pointsHeld":"Point_pointsHeld__ssjv8","score":"Point_score__FpJij","annotation":"Point_annotation__FuD1p"};